<script>
import responsiveMixin from '@/mixins/responsiveMixin';
import { required } from '@/utils/propTypes';

export default {
  mixins: [responsiveMixin],
  props: { currentStep: required(Number) },
};
</script>

<template>
  <div>
    <v-row
      justify="center"
      class="mt-12 content-wrapper"
      :class="responsiveClasses({ tablet: 'tablet', mobile: 'pl-3 pr-3' })"
    >
      <v-col
        md="3"
        cols="12"
        :class="
          responsiveClasses({ desktop: 'pr-0', tablet: 'pt-0 pr-0 pl-0' })
        "
      >
      </v-col>
      <v-col
        md="9"
        cols="12"
        :class="
          responsiveClasses({ desktop: 'pl-12', tablet: 'pt-0 pr-0 pl-0' })
        "
      >
        <v-container :class="responsiveClasses({ tablet: 'pt-0' })">
          <slot />
        </v-container>
      </v-col>
    </v-row>
    <div
      class="blue-triangle"
      :class="responsiveClasses({ tablet: 'mobile-or-tablet' })"
    />
  </div>
</template>

<style lang="scss" scoped>
.content-wrapper {
  margin-bottom: 160px;
}

.tablet {
  max-width: 576px;
  margin-left: auto;
  margin-right: auto;
}

.blue-triangle {
  position: absolute;
  bottom: -12px;
  right: 0;
  height: 0;
  width: 0;
  z-index: -1;
  border-bottom: 414px solid #0093ee;
  border-left: 475px solid transparent;

  &.mobile-or-tablet {
    border-bottom-width: 165px;
    border-left-width: 375px;
  }
}
</style>
